import React, { ComponentType } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

interface IFeatureItemProps {
  featureIcon: ComponentType
  featureText: string
  style: Object
}

const Item = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f2f2f2;
  width: 100%;
  height: 100%;
  padding: 20px;
  text-align: center;
`

export const FeatureItem = ({ featureIcon, featureText }: IFeatureItemProps) => {
  const FeatureIcon = styled(featureIcon)`
    font-size: 36px;
  `

  return (
    <Item>
      <FeatureIcon />
      <div style={{ fontSize: '18px' }}>{featureText}</div>
    </Item>
  )
}

export const AngleBackgroundTop = styled.div`
  width: 100vw;
  height: 100%;
  background-image: linear-gradient(176deg, #22313f 70%, #ffffff calc(70% + 2px));
`

export const PageHeader = styled.div`
  width: 100%;
  height: 40vh;
  min-height: 400px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  border: none;
  padding: 0;
  margin: 0;
`

export const HeaderTextWrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  color: white;
`
export const PriceSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 50px;
`
export const PriceTag = styled.div`
  text-shadow: 2px 1px 3px;
  font-weight: 600;
  font-size: 55px;
  margin-bottom: 15px;
`
export const Features = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
`
export const StartSection = styled.div`
  /* position: relative; */
  height: 40vh;
  min-height: 400px;
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 50px;
  color: white;
  background-image: linear-gradient(176deg, #ffffff 30%, #22313f calc(30% + 2px));
`

export const StyledLink = styled(Link)`
  color: #ffffff;
  font-size: 16px;
  padding: 15px 30px;
  width: 280px;
  height: 80px;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 3px;
  background-color: #29c086;
  &:hover {
    background-color: #229e6d;
  }
`
export const PricingFeaturesGrid = styled.div`
  display: grid;
  grid-gap: 10px;
  grid-template-areas:
    'box1'
    'box2'
    'box3'
    'box4'
    'box5'
    'box6';
  grid-template-rows: 1fr 1fr 1fr 1fr 1fr 1fr;

  @media (min-width: 450px) {
    width: 750px;
    grid-template-areas: 'box1 box2' 'box3 box4' 'box5 box6';
    grid-template-rows: 1fr 1fr 1fr;
    grid-template-columns: 1fr 1fr;
  }
`
const Box = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
`
export const PricingBox1 = styled(Box)`
  grid-area: box1;
`
export const PricingBox2 = styled(Box)`
  grid-area: box2;
`
export const PricingBox3 = styled(Box)`
  grid-area: box3;
`
export const PricingBox4 = styled(Box)`
  grid-area: box4;
`
export const PricingBox5 = styled(Box)`
  grid-area: box5;
`
export const PricingBox6 = styled(Box)`
  grid-area: box6;
`
